import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var MainLoadingService = /** @class */ (function () {
    function MainLoadingService() {
        this.loading = false;
        this.mainLoading = new Subject();
        this.mainLoadingChanged$ = this.mainLoading.asObservable();
        this.progressBar = new Subject();
        this.progressBarChanged$ = this.progressBar.asObservable();
    }
    MainLoadingService.prototype.setLoading = function (loading) {
        this.loading = loading;
        this.mainLoading.next(this.loading);
    };
    MainLoadingService.prototype.getLoading = function () {
        return this.loading;
    };
    MainLoadingService.prototype.clearLoading = function () {
        this.loading = false;
    };
    MainLoadingService.prototype.setProgressBar = function (isProgressing) {
        this.progressBar.next(isProgressing);
    };
    MainLoadingService.prototype.getProgressBar = function () {
        return this.progressBar;
    };
    MainLoadingService.ngInjectableDef = i0.defineInjectable({ factory: function MainLoadingService_Factory() { return new MainLoadingService(); }, token: MainLoadingService, providedIn: "root" });
    return MainLoadingService;
}());
export { MainLoadingService };
